import { render, staticRenderFns } from "./ReleasesTab.vue?vue&type=template&id=5bf8fdb2&"
import script from "./ReleasesTab.vue?vue&type=script&lang=ts&"
export * from "./ReleasesTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports